import React, { useState, useEffect, useRef } from 'react';
import { MdPrint, MdSave } from 'react-icons/md';
import apiService from "../config";
import { useSignature } from '../DigitalSignature/UseSignatue';
import SignaturePad from '../DigitalSignature/SignaturePad';

const Anusuchi3 = ({ onBack, setSubComponent }) => {
  const certificateContentRef = useRef();
  const [loading, setLoading] = useState(true);
  const [isSaving, setIsSaving] = useState(false);
  
  const [formData, setFormData] = useState({
    project_name: '',
    villages: '',
    taluka: '',
    district: '',
    proposal_no_name: '',
    officer1_name: '',
    officer1_designation: '',
    officer2_name: '',
    officer2_designation: '',
    date: new Date().toISOString().split('T')[0],
    place: ''
  });

  const {
    uploadStatus,
    selectedSignDocument,
    signDocument,
    resetSignatureState
  } = useSignature();

  const [showSignaturePad, setShowSignaturePad] = useState(false);
  const [pdfForSigning, setPdfForSigning] = useState(null);

  useEffect(() => {
    const loadData = async () => {
      try {
        setLoading(true);
        const project = JSON.parse(localStorage.getItem("selectedProject") || "{}");
        const projectId = project?.id || project?.project_id;
        const proposalId = localStorage.getItem("currentProposalId") || project?.acquisition_proposal_id;

        if (projectId && proposalId) {
          const result = await apiService.getProposalById(projectId, proposalId);
          if (result && result.status === 200) {
            const proposal = result.data;

            // Extract UNIQUE villages, talukas, and districts from the dtv array
            const dtvList = proposal.dtv || [];
            const villageNames = [...new Set(dtvList.map(item => item.village_name).filter(Boolean))].join(", ");
            const talukaNames = [...new Set(dtvList.map(item => item.taluka_name).filter(Boolean))].join(", ");
            const distNames = [...new Set(dtvList.map(item => item.dist_name).filter(Boolean))].join(", ");

            setFormData({
              project_name: project.project_name || '',
              villages: villageNames || proposal.village_name || '',
              taluka: talukaNames || proposal.taluka_name || '',
              district: distNames || proposal.dist_name || '',
              proposal_no_name: proposal.acquisition_proposal_no || '',
              officer1_name: proposal?.acquisition_regional_incharge_name || '',
              officer1_designation: proposal?.acquisition_regional_incharge_designation || '',
              officer2_name: proposal?.acquisition_incharge_name || '',
              officer2_designation: proposal?.acquisition_incharge_designation || '',
              date: proposal?.acquisition_proposal_date 
                ? proposal.acquisition_proposal_date.split('T')[0] 
                : new Date().toISOString().split('T')[0],
              place: proposal.acquisition_incharge_address || ''
            });
          }
        }
      } catch (error) {
        console.error("Error loading proposal data:", error);
      } finally {
        setLoading(false);
      }
    };
    loadData();
  }, []);

  const formatDate = (dateString) => {
    if (!dateString) return '';
    const [year, month, day] = dateString.split('-');
    return `${day}/${month}/${year}`;
  };

  const handlePrintView = () => {
    const printWindow = window.open('', '_blank');
    const content = certificateContentRef.current.innerHTML;

    const printHTML = `
      <!DOCTYPE html>
      <html>
      <head>
        <meta charset="UTF-8">
        <title>Anusuchi 3 Print</title>
        <style>
          @page { size: A4; margin: 1in; }
          body { 
            font-family: 'Noto Sans Devanagari', 'Arial', sans-serif; 
            line-height: 1.8; 
            color: black;
          }
          .cert-paragraph { 
            text-indent: 50px !important; 
            text-align: justify !important; 
            margin-bottom: 15px; 
            display: block;
          }
          .text-center { text-align: center; }
          .font-bold { font-weight: bold; }
          .signature-section { 
            display: flex; 
            justify-content: space-between; 
            margin-top: 60px; 
          }
          .signature-block { text-align: center; min-width: 200px; }
        </style>
      </head>
      <body>
        ${content}
        <script>
          window.onload = function() { window.print(); window.close(); };
        </script>
      </body>
      </html>
    `;
    printWindow.document.write(printHTML);
    printWindow.document.close();
  };

  const handleSaveEdits = async () => {
    setIsSaving(true);
    try {
      const project = JSON.parse(localStorage.getItem("selectedProject") || "{}");
      const projectId = project?.id || project?.project_id;
      const proposalId = localStorage.getItem("currentProposalId") || project?.acquisition_proposal_id;

      const p1Text = document.getElementById('para1')?.innerText || '';
      const p2Text = document.getElementById('para2')?.innerText || '';
      const p3Text = document.getElementById('para3')?.innerText || '';
      const p4Text = document.getElementById('para4')?.innerText || '';

      const payload = {
        project_id: projectId,
        proposal_id: proposalId,
        certificate_type: "anusuchi3",
        content: {
          paragraph_1: p1Text,
          paragraph_2: p2Text,
          paragraph_3: p3Text,
          paragraph_4: p4Text,
        }
      };

      console.log("Data to be saved:", payload);
      // await apiService.saveCertificateEdits(payload);
      
      alert("बदल यशस्वीरीत्या सेव्ह झाले! (Changes saved successfully!)");
    } catch (error) {
      console.error("Error saving edits:", error);
      alert("बदल सेव्ह करताना त्रुटी आली. (Error saving changes.)");
    } finally {
      setIsSaving(false);
    }
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 p-4">
      <div className="max-w-5xl mx-auto">
        <div className="bg-white p-6 rounded-xl shadow-md mb-6 flex justify-between items-center border border-gray-200">
          <div>
            <h1 className="text-2xl font-bold text-gray-800">प्रस्ताव प्रमाणपत्र</h1>
            <p className="text-sm text-gray-500">परिशिष्ट - ३ (Anusuchi 3)</p>
          </div>
          
          <div className="flex gap-3">
            {/* <button
              onClick={handleSaveEdits}
              disabled={isSaving}
              className={`flex items-center gap-2 px-6 py-2 rounded-lg transition-colors shadow-lg text-white ${
                isSaving ? 'bg-blue-400 cursor-not-allowed' : 'bg-blue-600 hover:bg-blue-700'
              }`}
            >
              <MdSave size={20} />
              <span>{isSaving ? 'सेव्ह करत आहे...' : 'सेव्ह करा'}</span>
            </button> */}

            <button
              onClick={handlePrintView}
              className="flex items-center gap-2 bg-green-600 hover:bg-green-700 text-white px-6 py-2 rounded-lg transition-colors shadow-lg"
            >
              <MdPrint size={20} />
              <span>प्रिंट करा</span>
            </button>
          </div>
        </div>

        <div 
          className="bg-white p-12 rounded-xl shadow-lg border border-gray-200 overflow-hidden"
          ref={certificateContentRef}
        >
          <div className="text-center mb-6">
            <h3 className="font-bold text-lg mb-2">परिशिष्ट - 3</h3>
            <h3 className="font-bold text-md">प्रकल्प नाव: {formData.project_name}</h3>
            <h3 className="font-bold text-md">प्रस्ताव नाव: {formData.proposal_no_name}</h3>
            <p className="font-bold mt-2">
              मौजे : {formData.villages} | तालुका : {formData.taluka} | जिल्हा : {formData.district}
            </p>
          </div>

          <div className="text-center text-xl font-bold underline mb-10">प्रस्ताव प्रमाणपत्र</div>

          <div className="certificate-body text-gray-900">
            <p 
              id="para1"
              className="cert-paragraph mb-6  outline-none focus:bg-yellow-50 focus:ring-1 focus:ring-yellow-400 p-1 rounded transition-colors" 
              // contentEditable="true" 
              suppressContentEditableWarning={true}
              style={{ textIndent: '50px', textAlign: 'justify' }}
            >
              प्रमाणित करण्यात येते की, <span>{formData.project_name}</span> या प्रकल्पाच्या आखणीमध्ये समाविष्ट असलेल्या प्रस्तावित जमिनीचे सीमांकन करण्यात आले आहे. प्रस्तावित जमिनीचा ताबा खाजगी वाटाघाटीने किंवा इतर कोणत्याही मार्गाने घेतलेला नाही.
            </p>

            <p 
              id="para2"
              className="cert-paragraph mb-6  outline-none focus:bg-yellow-50 focus:ring-1 focus:ring-yellow-400 p-1 rounded transition-colors" 
              // contentEditable="true" 
              suppressContentEditableWarning={true}
              style={{ textIndent: '50px', textAlign: 'justify' }}
            >
              प्रकल्पाच्या आखणीमध्ये समाविष्ट वन जमिनी वन विभागाकडून हस्तांतरीत करण्याबाबत आणि त्याप्रमाणे आवश्यक कार्यवाही प्रादेशिक विभाग/प्राधिकरण/महामंडळाच्या वतीने स्वतंत्ररीत्या कार्यान्वित करण्यात येत आहे.
            </p>

            <p 
              id="para3"
              className="cert-paragraph mb-6 outline-none focus:bg-yellow-50 focus:ring-1 focus:ring-yellow-400 p-1 rounded transition-colors" 
              // contentEditable="true" 
              suppressContentEditableWarning={true}
              style={{ textIndent: '50px', textAlign: 'justify' }}
            >
              प्रकल्पाच्या आखणीमध्ये समाविष्ट शासकीय जमिनी /इतर विभागांच्या जमिनी महामंडळास हस्तांतरीत करण्याबाबत आणि त्याप्रमाणे आवश्यक कार्यवाही प्रादेशिक विभाग/प्राधिकरण/महामंडळाच्या वतीने स्वतंत्ररीत्या कार्यान्वित करण्यात येत आहे.
            </p>

            <p 
              id="para4"
              className="cert-paragraph mb-6 outline-none focus:bg-yellow-50 focus:ring-1 focus:ring-yellow-400 p-1 rounded transition-colors" 
              // contentEditable="true" 
              suppressContentEditableWarning={true}
              style={{ textIndent: '50px', textAlign: 'justify' }}
            >
              सदरचा प्रस्ताव यापूर्वी प्रादेशिक विभाग/प्राधिकरण/महामंडळामार्फत दाखल केलेला नाही.
            </p>
          </div>

          <div className="mt-12 ">
            <div className="mb-2 ">दिनांक :- <span className="font-normal">{formatDate(formData.date)}</span></div>
            <div className="">ठिकाण :- <span className="font-normal">{formData.place}</span></div>
          </div>

          <div className="signature-section flex justify-between mt-16 pb-10">
            <div className="signature-block text-center">
              <div className=" mb-1">({formData.officer1_name})</div>
              <div className="">{formData.officer1_designation}</div>
            </div>
            <div className="signature-block text-center">
              <div className=" mb-1">({formData.officer2_name})</div>
              <div className="">{formData.officer2_designation}</div>
            </div>
          </div>
        </div>
      </div>

      {showSignaturePad && pdfForSigning && (
        <SignaturePad
          pdfFile={pdfForSigning}
          onSign={(signaturesArray) => {
            setShowSignaturePad(false);
            signDocument(pdfForSigning, signaturesArray);
            setPdfForSigning(null);
          }}
          onCancel={() => {
            setShowSignaturePad(false);
            setPdfForSigning(null);
          }}
        />
      )}
    </div>
  );
};

export default Anusuchi3;